import React, { useState } from 'react';
import {Provider, useSelector } from 'react-redux';
import store from '@state/store';
import { selectProduct } from '@components/ProductDetail/state/productDetailSlice';
import { ProductTile } from '@components-react/ProductTile/ProductTile';
import { useBrowserLayoutEffect } from '@hooks/useBrowserLayoutEffect';
import { mapProductData } from '@utils/mapProductsData';
import type { Product, Media as MediaData } from '@sctypes/product/Product';
import type { ScProps } from '@components-react/ScProps';

interface AddToCartProps {
  amount: string;
  addToCart: string;
  enabled: boolean;
  products?: Product[];
  showAddToCartButton?: boolean;
}

export const EndOfLifeProductReplacement = (props: ScProps<AddToCartProps>) => {
  const eolProduct = useSelector(state => selectProduct(state));
  const [substitutionProduct, setSubstitutionProduct] = useState<Product | null>(null);

  useBrowserLayoutEffect(() => {
    const substitution = eolProduct?.variants?.find((variant: any) => variant?.substitutionProduct)?.substitutionProduct;
    setSubstitutionProduct(substitution || null);

    setTimeout(() => {
      const elem = document.querySelector('[class*="component product-media-carousel"]');
      // @ts-expect-error: lib.dom definitions incorrect
      elem.style.filter = 'blur(7px) grayscale(80%)';
      // @ts-expect-error: lib.dom definitions incorrect
      elem.style.pointerEvents = 'none';
    }, 0);
  }, [eolProduct]);



  const getPhrases = () => {
    try {
      const el = document.querySelector('[data-component=add-to-cart]');
      return el ? JSON.parse(el.textContent || '{}')?.Phrases ?? {} : {};
    } catch {
      return {};
    }
  };

  if (!substitutionProduct) {
    return null;
  }


  const product = mapProductData(substitutionProduct);
  return (
    <div>
      <h2 data-trans className="h2 text-primary mb-2">Bekijk onze vervangende product</h2>
      <ProductTile
        key={`${product.defaultVariantCode}-${product.code}`}
        product={product}
        phrases={getPhrases()}
        prices={undefined}
        fallbackImage={product?.variants?.[0]?.media?.[0] as MediaData | undefined}
        showAddToCartButton={props.data?.showAddToCartButton ?? true}
      />
    </div>

  );
};



export const ProvideEndOfLifeProductReplacement = (props: any) => {

  return (
    <Provider store={store}>
      <EndOfLifeProductReplacement {...props} />
    </Provider>
  );
};
